import { Reducer, useReducer } from 'react'
import { TReducerAction } from '../interfaces/FormFields'

function useStyledSelect(placeHolder: string) {
  const initialState = {
    selectedOption: placeHolder,
    showOptionsDropdown: false,
  }
  let showOptionsDropdown = false
  const reducer: Reducer<typeof initialState, TReducerAction> = (
    state,
    action
  ) => {
    switch (action.type) {
      case 'clickOutsideCloseDropdown':
        if (action.payload && action.payload.toggleOptionDropdown) {
          showOptionsDropdown = !state.showOptionsDropdown
        }
        return {
          ...state,
          showOptionsDropdown,
        }
      case 'isOptionSelected':
        return action.payload
      default:
        return initialState
    }
  }
  const [state, dispatch] = useReducer(reducer, initialState)

  return { state, dispatch }
}

export default useStyledSelect
